import { Column, Container, Row } from '@iag-packages/chroma-react/lib/layouts';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';

import PolicyText from './PolicyText';

const FooterBottomWrapper = styled.div`
  .row {
    justify-content: center;
  }
`;

const IAGLogo = styled.img`
  width: 180px;
`;

const IAGLogoContainer = styled.div`
  display: flex;
  justify-content: start;
  padding-bottom: 1em;
  max-height: 4em;
  margin-left: -1rem;
`;

export const FooterBottom: FunctionComponent<{
  disclaimers?: Array<FunctionComponent>;
}> = ({ disclaimers }) => (
  <FooterBottomWrapper>
    <Container>
      <Row>
        <Column xs={12} md={10}>
          {disclaimers && disclaimers.map((Disclaimer) => <Disclaimer />)}
          <PolicyText />
          <IAGLogoContainer>
            <IAGLogo
              src={ICONS.LOGO.BACKED_BY_IAG}
              tabIndex={-1}
              alt="Backed by IAG Logo"
            />
          </IAGLogoContainer>
        </Column>
      </Row>
    </Container>
  </FooterBottomWrapper>
);
